import {AppService} from "@core/services/app.service";

export function checkClickDuplicateMenu(url: string, app: AppService) {
  if (!url) {
    return;
  }

  if (url === app.currentUrl) {
    app.menuClickSubject$.next(url);
  }
}
